import React from 'react';
import { Link } from "react-router-dom";
import './return.scss';
import { ReactComponent as ImportingBtnIconPreview } from '../../img/importingBtnIconPreview.svg';
import Tooltip from "../tooltip/Tooltip";


export default function Return() {
  return (
    <Link to="/" className='preview_return-link'>
      <Tooltip
        content={'Preview'}
        direction="bottom"
        dirStyle="importing"
      >
        <button id='returnBtn' className='preview_return-btn'><ImportingBtnIconPreview /></button>
      </Tooltip>
    </Link>
  );
}
